module.exports = __webpack_public_path__ + "img/W-G19.b37f7172.jpg";